import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Container,
  CssBaseline,
  Snackbar,
  SnackbarContent,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles,useTheme } from "@material-ui/core/styles";
import { Error, Close, Email,Help } from "@material-ui/icons";

import { useHistory,useParams } from "react-router-dom";
import MaskedInput from "react-text-mask";
import PinInput from 'react-pin-input'
import { useSnackbar } from "notistack";


import icon from "../../assets/img/logo_white.svg";

import { AdminService, FinanceService, ReportingService } from "../../utils/web_config";
import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
}));



function ConfirmEmail(props) {
  const classes = useStyles();
  const history = useHistory();

  const theme=useTheme();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [accountData, setAccountData] = useState({});

  const [tkn, setTkn] = useState("");

  const [otp, setOtp] = useState({ value: "", error: "" });
  const [confirming, setConfirming] = useState(false);
  const [snackOpen, openSnack] = React.useState({ open: false, msg: "" });

  const handleSnackClose = (event, reason) => {
    openSnack({ open: false, msg: "" });
  };

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);

    var tkn=history.location.search?.replace("?tkn=","")
    console.log(tkn)
    if(tkn==null || tkn==''){
      history.replace("/")
    }else{
      setTkn(tkn)
    }
  
  }, []);

  const onOtpChange = (v,i) => {
    if (v === "") {
      notify( "error", "Enter OTP number sent to your phone" );
    } else {
      setOtp({ value: v, error: "" });
    }
  };

  const onConfirmClick = () => {
    if (otp.value === "") {
      notify( "error", "Enter OTP number sent to your phone" );
    } else {
       doConfirm();
    }
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const doConfirm = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setConfirming(true);

    const data ={
    "tkn": tkn,
    "otp": otp.value
}

    createInstance
      .post(new ReportingService().CONFIRM_EMAIL, data)
      .then(function (response) {
        setConfirming(false);

        const d = response.data;

        notify("success", d.message);

        setTimeout(() => {
          history.replace("/")
        }, 500);
      })
      .catch(function (error) {
        setConfirming(false);

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={snackOpen.open}
        autoHideDuration={5000}
        onClose={handleSnackClose}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
      >
        <SnackbarContent
          className={classes.error}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              <Error className={classes.icon} />
              {snackOpen.msg}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={handleSnackClose}
            >
              <Close className={classes.icon2} />
            </IconButton>,
          ]}
        />
      </Snackbar>
      <CssBaseline />
      <AppBar position="static" color="primary" elevation={0}>
        <Toolbar> <Box mr={2}>
            <img
              src={icon}
              style={{ height: 45 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
          </Box>

          <Typography variant="h6" className={classes.title}>
            Email confirmation
          </Typography>
          <IconButton>
            <Help />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box pt={10}>
          <Paper className={classes.paper}>
            <Box p={2} display="flex" flexDirection="column">
              <Box
                mb={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Box mr={2}>
                  <Email fontSize="large" />
                </Box>
                <Typography variant="h4">Confirm your email.</Typography>
              </Box>
              <Typography color="textSecondary" align="center">
                Enter OTP number sent to your phone to confirm your email.
              </Typography>
            </Box>
            <Box mt={3} width={1} display='flex' justifyContent='center'>
            <PinInput 
  length={4} 
  initialValue=""
  //secret 
  onChange={onOtpChange}
  type="numeric" 
  inputMode="number"
  style={{padding: '10px',borderRadius:"7px"}}  
  inputStyle={{borderColor: theme.palette.secondary.main}}
  inputFocusStyle={{borderColor: theme.palette.primary.main}}
  onComplete={(value, index) => {}}
  autoSelect={true}

/>
             
            </Box>

            {confirming && (
              <Box mt={2} display="flex" justifyContent="center">
                <CircularProgress />
              </Box>
            )}
            <Box mt={2} mb={2}>
              <Button
                disabled={confirming}
                color="primary"
                fullWidth
                variant="contained"
                disableElevation
                onClick={onConfirmClick}
              >
                Confirm emeil
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </div>
  );
}

export default ConfirmEmail;
